package one.healthium.onboarding.domain.configs

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("input_text")
data class TextInputScreenConfig(
    @SerialName("title") val title: String? = null,
    @SerialName("hint") val hint: String? = null,
    @SerialName("cta_title") val ctaTitle: String? = null,
    @SerialName("default_hint") val defaultHint: String? = null,
    @SerialName("required") val required: Boolean = true,
) : ScreenConfig